const handleOtp = (state = {}, action) => {
    switch (action.type) {
      case 'SET_OTP':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleOtp;